import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux';
import { SidebarDistributionLineAreaMasterPostDataAPI } from '../../../../../../Redux/SidebarMasterSlice/WaterSupplySidebarSlice/WaterSupplyDistributionLineAreaMasterSlice';
import { useAuthState } from '../../../../../../Helper/Context';
import { JunctionNameDataDDL } from '../../../../../../Components/CommonDDL/JunctionNameDataDDL';
import { DistributionLineLocationDataDDL } from '../../../../../../Components/CommonDDL/DistributionLineLocationDataDDL';
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL';
import { WaterSupplyMainLineJunctionMasterPostDataAPI } from '../../../../../../Redux/SidebarMasterSlice/WaterSupplySidebarSlice/WaterSupplyMainLineJunctionMasterSlice';


export default function WSJunctionMasterPopUp(props) {
    const { handleOnCloseClick, open, Flag, apiFlag, rowData, handleIsPost, DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch();

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_WardID : 0,
        Label: Flag === 'Update' ? rowData.wardName : "Select...",
    })

    const [JunctionName, setJunctionName] = useState(Flag === 'Update' ? rowData.junctionDetails : '')
    const [IsClear, setIsClear] = useState(false)

    const [IsOpen, setIsOpen] = useState(false)


    const handleClear = () => {
        setIsClear(!IsClear)
        setJunctionName('')
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
    }

    const handlePost = () => {
        const data = {

            M_WS_JunctionID: Flag === 'Update' ? rowData.m_wS_JunctionID : '0',
            M_WardID: WardName.ID,
            JunctionDetails: JunctionName,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
            DashProjectTypeId: DashProjectTypeId,

        }
        dispatch(WaterSupplyMainLineJunctionMasterPostDataAPI({ data }))
    }
    const { isPostLoading } = useSelector(state => state.WaterSupplyMainLineJunctionMasterPostData)

    return (
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="modal-dialog water_pop modal-xl">
                <div className="modal-content">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Junction Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">

                                <div className="col-12 col-md-6 col-lg-6">
                                    <WardNameDataDDL
                                        WardName={WardName}
                                        setWardName={setWardName}
                                        rowData={rowData}
                                        Flag={Flag}

                                    // Flag='ward'
                                    />
                                </div>


                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Junction Name </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="JunctionName"
                                            value={JunctionName}
                                            onChange={(e) => setJunctionName(e.target.value)}

                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-lg-12 pt-lg-5">
                                <div className="btn-action d-flex justify-content-end ">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => (handlePost(), handleClear())}
                                        disabled={
                                            WardName.ID == 0 || JunctionName == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}